export default "__VITE_ASSET__FoGBk38M__"